import * as v from "valibot";

import { rpcContract } from "../rpc";

export const verifyCheckoutAuthTokenRpcContract = rpcContract({
  paramsSchema: v.object({
    token: v.string(),
  }),
  resultSchema: v.object({
    accessToken: v.string(),
  }),
  name: "verify-checkout-auth-token",
});

export type VerifyCheckoutAuthTokenParams = v.InferOutput<(typeof verifyCheckoutAuthTokenRpcContract)["paramsSchema"]>;
export type VerifyCheckoutAuthTokenResult = v.InferOutput<(typeof verifyCheckoutAuthTokenRpcContract)["resultSchema"]>;
export enum VerifyCheckoutAuthTokenErrorMessages {
  InvalidToken = "invalid-token",
  UserNotFound = "user-not-found",
}
